var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtLifestyle = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.133 25.836c-.706.136-1.127 1.061-.768 1.688-.417.141-.913.386-.917.83-.001.14.052.282.018.418-.076.312-.505.353-.739.571-.173.161-.227.41-.274.642-.07.353-.034.864.324.893.427.036.478-.662.836-.898.142.5.988.543 1.179.06-.002.448.53.769.958.647.43-.122.711-.564.766-1.01.208.194.558.141.783-.034.224-.176.358-.44.498-.689.067-.118.153-.245.286-.266.247-.039.365.287.54.466.285.288.803.17 1.07-.134.267-.305.349-.726.42-1.125.294.306.853.194 1.107-.147.254-.341.254-.818.127-1.224 1.012.114 1.962-.976 1.717-1.972.396-.43 1.226-.212 1.56-.692.247-.355-.03-.92-.456-.987-.426-.068-.846.314-.88.746a1.195 1.195 0 0 0-1.278-.65c-.505.101-.911.577-.934 1.095-.454-.307-1.143-.174-1.452.28-.745-.62-1.788-.909-2.711-.623-.924.285-1.656 1.201-1.61 2.172",
    fill: "#9C4F37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.574 14.957a3.173 3.173 0 0 1-.82-2.879c.053-.228.13-.45.219-.667.078-.191.167-.382.3-.539.154-.18.358-.306.542-.455.764-.617 1.14-1.588 1.433-2.528.121.28.159.588.196.891l.1.844c.086.708.171 1.416.18 2.13.006.43-.016.865-.134 1.28-.161.568-.496 1.075-.9 1.505-.14.149-.291.292-.473.387a.804.804 0 0 1-.592.078",
    fill: "#B7B739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.673 14.857a3.029 3.029 0 0 1-.792-2.699c.061-.287.16-.57.283-.836.058-.127.126-.254.218-.36a1.89 1.89 0 0 1 .3-.267c.216-.162.42-.327.599-.53.168-.192.315-.403.442-.623.292-.505.488-1.06.66-1.616l-.256.034c.096.226.134.477.164.719.034.27.065.54.097.809.067.557.137 1.114.173 1.675.036.56.056 1.084-.052 1.61a3.262 3.262 0 0 1-.607 1.3c-.158.21-.338.417-.54.586-.202.17-.447.277-.698.207-.175-.049-.25.224-.075.273.55.154 1.008-.269 1.34-.653.33-.383.613-.831.77-1.324.174-.543.182-1.126.16-1.69a22.417 22.417 0 0 0-.164-1.78l-.116-.964c-.039-.32-.085-.62-.209-.912-.05-.12-.224-.07-.257.034-.155.498-.327.992-.577 1.45a3.71 3.71 0 0 1-.424.63 3.68 3.68 0 0 1-.58.528c-.12.09-.24.182-.34.295-.1.113-.173.23-.238.359a4.295 4.295 0 0 0-.32.875 3.282 3.282 0 0 0 .005 1.556c.139.568.428 1.098.837 1.514.127.13.326-.07.199-.2h-.002z",
    fill: "#B7B73A"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#B7B73A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.944 12.441c-.7-.175-1.268-.734-1.566-1.395-.298-.661-.35-1.414-.264-2.135.036-.31.097-.622.079-.934-.017-.29-.1-.572-.185-.85-.165-.55-.36-1.142-.83-1.467.639.098 1.293.201 1.86.514.568.314 1.006.817 1.422 1.317.146.177.292.356.395.56.084.167.137.347.19.526.236.8.472 1.664.2 2.453-.089.26-.23.501-.402.716-.24.303-.544.563-.904.699"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98 12.305a2.152 2.152 0 0 1-1.104-.723c-.32-.382-.51-.856-.598-1.343-.101-.559-.051-1.113.021-1.671.04-.304.051-.6-.005-.904-.049-.264-.131-.524-.213-.78-.163-.512-.38-1.029-.832-1.347l-.109.26c.598.09 1.217.182 1.76.464.545.281.935.708 1.313 1.154.197.232.407.464.538.742.065.138.108.286.152.433.043.146.089.302.13.455.162.605.288 1.258.101 1.873a2.29 2.29 0 0 1-.479.835 1.94 1.94 0 0 1-.753.554c-.07.028-.12.096-.098.175.018.069.101.126.173.1.576-.222 1.05-.719 1.309-1.278.292-.63.252-1.324.104-1.987a11.135 11.135 0 0 0-.268-.972 2.286 2.286 0 0 0-.206-.476 3.26 3.26 0 0 0-.29-.4c-.397-.483-.813-.97-1.342-1.312-.619-.401-1.353-.524-2.069-.633-.156-.024-.244.163-.108.259.373.262.554.715.69 1.135.082.257.166.518.219.783.058.294.039.586 0 .881-.04.295-.075.572-.08.862-.004.29.017.566.066.846.09.516.292 1.005.615 1.418.322.412.776.739 1.289.87.176.045.25-.229.075-.273z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.419 9.349c-.246 1.584.344 3.203 1.248 4.523.903 1.32 2.104 2.399 3.252 3.51a62.16 62.16 0 0 1 2.904 3.01c.73.808 1.443 1.644 1.972 2.597.529.954.868 2.041.793 3.131a2.23 2.23 0 0 0 1.69-.501c-.877-2.286-2.399-4.267-4.094-6.025-1.695-1.758-3.576-3.323-5.337-5.014-.63-.604-1.253-1.237-1.662-2.01-.55-1.042-.67-2.252-.78-3.427",
    fill: "#9FA438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.98 17.13a6.832 6.832 0 0 1-.116-4.779c-.235.868-.18 1.797.045 2.667.226.87.616 1.69 1.047 2.477a1.745 1.745 0 0 1-1.265-1.17M5.524 18.463c1.053.203 2.045.62 3.07.928.515.155 1.04.28 1.576.339.266.029.532.04.8.029.266-.012.542-.044.812-.07.555-.052 1.15-.082 1.662.18.161.081.304-.163.142-.246-.46-.235-.983-.273-1.492-.243-.546.034-1.084.122-1.633.09-1.077-.062-2.102-.447-3.115-.79-.574-.193-1.152-.376-1.748-.49-.074-.015-.152.02-.173.099-.02.069.023.16.098.174h.001z",
    fill: "#9FA438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.527 18.412c1.046.519 2.128.966 3.236 1.332.555.183 1.119.337 1.7.41.597.075 1.197.028 1.798.028.598 0 1.22.054 1.753.352.143.08.275-.103.17-.223-.214-.245-.422-.497-.645-.735-.197-.21-.504-.38-.78-.208-.155.095-.014.34.141.244.2-.123.404.121.521.255l.565.644.17-.222c-1.04-.58-2.245-.314-3.373-.388-.576-.038-1.14-.178-1.69-.349a24.228 24.228 0 0 1-3.424-1.385c-.067-.034-.151-.018-.192.051-.036.063-.018.16.05.194z",
    fill: "#9FA438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.468 19.645a3.129 3.129 0 0 0-.545-.026c-.166.007-.345.052-.509.013l-.037.278.583.041c.09.007.18.012.27.02a1.33 1.33 0 0 1 .187.027l.024.007c.038.014.034.006-.012-.023l-.02-.071.002.014.104-.137a2.84 2.84 0 0 1-.74.026c-.246-.024-.491-.079-.74-.085-.181-.004-.181.279 0 .284.258.006.51.065.767.086.257.022.527.006.788-.038.056-.01.108-.08.104-.136-.01-.132-.11-.18-.226-.205-.116-.025-.237-.033-.355-.041l-.735-.052c-.158-.012-.19.242-.037.278.186.044.37.008.557-.002.187-.01.382 0 .572.025.075.01.14-.072.14-.142 0-.085-.065-.131-.14-.141h-.002z",
    fill: "#9FA438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.193 19.08c-.26-.733-.837-1.343-1.596-1.688-.833-.378-1.84-.431-2.824-.376-.985.055-1.976.21-2.957.226.673.965 1.55 1.793 2.497 2.543.475.375.977.738 1.58.946.45.155.942.22 1.43.28.25.03.511.058.76-.024.144-.047.274-.128.4-.212.24-.16.478-.34.617-.575.2-.338.162-.723.116-1.08",
    fill: "#B7B739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.329 19.044c-.337-.94-1.122-1.618-2.052-1.928-1.086-.361-2.269-.278-3.388-.171-.69.065-1.38.144-2.072.155-.1.002-.185.122-.122.213.773 1.104 1.785 2.038 2.862 2.836.263.194.538.376.83.521.314.156.645.266.987.338.342.071.716.12 1.075.159.174.018.348.023.521-.006.174-.03.346-.111.5-.208.301-.19.624-.419.787-.747.164-.328.147-.719.1-1.085-.01-.076-.057-.142-.14-.142-.069 0-.15.065-.14.142.036.292.074.607-.038.888-.113.28-.36.464-.597.624-.132.089-.268.18-.421.226a1.303 1.303 0 0 1-.47.034 8.82 8.82 0 0 1-1.012-.14 3.87 3.87 0 0 1-.921-.284 5.024 5.024 0 0 1-.813-.486c-.512-.368-.998-.78-1.457-1.212a10.39 10.39 0 0 1-1.41-1.6l-.122.212c1.178-.019 2.344-.237 3.523-.243.995-.006 2.069.137 2.865.791.38.314.685.72.853 1.187.026.072.096.12.173.1.07-.02.125-.102.099-.175z",
    fill: "#B7B73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.139 19.682-.49-.05v.284a2.75 2.75 0 0 1 .666-.003c.147.017.178-.195.07-.264-.18-.115-.393-.068-.586-.011-.209.062-.42.108-.638.128a3.968 3.968 0 0 1-1.334-.126 3.946 3.946 0 0 1-.695-.226l-.071.264c.95.12 1.906.2 2.863.243.181.008.18-.275 0-.283a35.597 35.597 0 0 1-2.863-.244c-.137-.017-.194.208-.071.264.4.184.844.296 1.279.36.455.067.913.06 1.364-.043.115-.026.227-.063.341-.092.09-.022.187-.042.27.012l.07-.264a2.779 2.779 0 0 0-.665.002c-.178.023-.183.266 0 .284l.489.049c.076.007.14-.07.14-.142 0-.083-.064-.134-.14-.142z",
    fill: "#9FA438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.535 19.877c-.363-.07-.708-.22-1.053-.349l-1.075-.403c-.14-.053-.225.14-.136.237.726.793 1.867.828 2.861.766.18-.011.182-.295 0-.283-.918.057-1.988.053-2.663-.684l-.136.237 1.074.403c.358.134.69.279 1.053.349.075.014.152-.021.174-.1.019-.069-.023-.16-.099-.174z",
    fill: "#9FA438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.872 5.962c.372-.01.735.069 1.08.207.333.135.66.327.934.561.291.25.485.572.665.906.18.334.342.695.407 1.081.073.427.032.87-.104 1.28-.057.174.215.248.272.076a2.93 2.93 0 0 0 .129-1.254 3.469 3.469 0 0 0-.388-1.189c-.195-.376-.388-.727-.682-1.009a3.503 3.503 0 0 0-.99-.652 3.004 3.004 0 0 0-1.323-.29c-.18.005-.181.289 0 .284v-.001zM4.264 5.796a.276.276 0 0 0-.216-.136c-.018-.001-.036.018-.035.036.002.02.016.034.035.035h.007c.005 0 .005 0 0 0 .005 0 .01.002.014.003a.21.21 0 0 1 .025.006l.012.005c.008.003-.007-.003.001 0l.005.003a.203.203 0 0 1 .025.013l.01.007.006.004c-.004-.003-.002-.002 0 0a.3.3 0 0 1 .02.018l.01.01c0 .002.002.004.004.006 0 0 .005.006 0 0l.015.023c.009.016.032.024.048.013a.036.036 0 0 0 .013-.049l.001.003z",
    fill: "#B7B73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.126 5.7a.849.849 0 0 0-.35-.118l.018.066c.21-.108.451-.088.674-.033.223.054.448.129.666.206.043.016.062-.053.019-.068a5.585 5.585 0 0 0-.743-.224c-.22-.045-.448-.046-.653.058-.034.017-.013.062.018.066.113.012.219.049.315.108.04.024.075-.037.036-.06z",
    fill: "#B7B73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.914 5.626c.017-.009.04-.004.057-.002a1.78 1.78 0 0 1 .226.033c.019.004.038-.005.044-.025.004-.017-.006-.04-.025-.043a2.28 2.28 0 0 0-.174-.028c-.053-.007-.114-.021-.164.004-.017.009-.022.033-.012.049.01.018.03.022.048.012z",
    fill: "#B7B73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.961 5.633c.086.019.172.04.257.065a.036.036 0 0 0 .044-.025.036.036 0 0 0-.025-.044 5.024 5.024 0 0 0-.257-.065c-.019-.004-.039.006-.044.025-.005.018.006.04.025.044z",
    fill: "#B7B73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99 5.707c.157.103.305.22.44.351.033.032.083-.018.05-.05a3.052 3.052 0 0 0-.455-.362c-.038-.025-.073.037-.035.062v-.001zM4.082 5.581c.14-.018.295.018.436.032l.466.048c.155.016.294.032.437.075.143.042.289.108.425.18.04.021.076-.04.036-.061-.13-.07-.265-.131-.406-.176a2.188 2.188 0 0 0-.438-.084l-.48-.049-.244-.025c-.076-.008-.154-.02-.231-.011-.045.005-.045.076 0 .07l-.001.001z",
    fill: "#B7B73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.026 5.716c.177.069.358.125.542.168.044.01.063-.058.019-.069a4.05 4.05 0 0 1-.542-.168c-.042-.016-.06.053-.019.069z",
    fill: "#B7B73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.14 5.741.003-.003c.003-.003.002-.003-.002 0l.006-.003c.004-.002.003-.002-.001 0l.004-.001.007-.002.006-.001H5.16h.028l.046.002a.29.29 0 0 1 .023.003c.002 0 .013.002.006 0a.71.71 0 0 1 .013.002c.018.003.039-.005.043-.027.004-.019-.005-.045-.025-.048a.698.698 0 0 0-.113-.01c-.033 0-.07.005-.092.034-.012.015-.015.04 0 .054.013.014.037.017.05 0zM12.13 8.014c.02-.156.022-.312.004-.47l-.045.035c.175.068.252.307.302.47.061.198.085.404.075.61-.002.046.068.046.07 0a1.841 1.841 0 0 0-.095-.685c-.062-.178-.145-.39-.333-.463-.02-.008-.047.012-.045.034.018.156.017.313-.003.47-.005.045.065.044.07 0z",
    fill: "#B7B73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.072 7.81a4.653 4.653 0 0 1-.083.528c-.01.044.058.063.068.019.04-.18.068-.363.086-.547.004-.045-.066-.044-.07 0z",
    fill: "#B7B73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1 7.645a.976.976 0 0 1 .09.199l.069-.019a.67.67 0 0 1-.03-.088l-.01-.044-.004-.021-.002-.012a.064.064 0 0 0 0-.008l-.07.01a.816.816 0 0 0 .062.124c.01.015.028.021.044.014a.035.035 0 0 0 .02-.042.313.313 0 0 0-.04-.088l-.062.036a.232.232 0 0 1 .023.038l.002.005c-.001-.002-.001-.003 0 0l.003.01.007.023.033-.045h.003-.004.002l-.004-.002-.016-.012c-.016-.01-.034-.015-.052-.01-.045.013-.052.077-.053.116l.053-.03c.005.003-.002-.002.001 0 .003.004-.002-.006 0 .002-.007-.017-.024-.03-.043-.025-.017.006-.032.025-.025.044.006.017.016.03.03.04.024.015.053-.005.054-.03v-.02c0 .003 0 .003 0 0a.122.122 0 0 1 .005-.023l.004-.011c-.003.01 0-.004.001-.002 0 .002-.006.006-.009.006-.006 0-.007.001-.003.001h-.004c.002 0-.007-.005 0 0l.006.005.013.008a.073.073 0 0 0 .041.014c.024 0 .04-.023.034-.045a.25.25 0 0 0-.04-.092c-.012-.015-.032-.024-.05-.012-.015.01-.023.032-.012.048a.291.291 0 0 1 .022.037l.004.008a343.7 343.7 0 0 0 .009.026l.064-.027a.644.644 0 0 1-.045-.082c-.004-.01-.008-.017-.01-.025-.007-.016-.02-.027-.04-.025-.014.002-.032.017-.03.034.009.066.025.13.05.192.006.017.023.031.043.025.017-.006.03-.025.024-.044a1.091 1.091 0 0 0-.097-.215c-.01-.016-.032-.023-.048-.012a.036.036 0 0 0-.013.048v-.002zM2.788 17.33l-.14-.254c-.019-.036-.072-.01-.063.027a.426.426 0 0 0 .105.2c.028.03.074-.008.055-.043l-.126-.236c-.022-.04-.08-.005-.06.036l.036.08.06-.036a1.103 1.103 0 0 1-.065-.115l-.056.043c.096.093.234.113.36.128.153.019.307.02.46.02.046 0 .047-.07 0-.07-.138-.001-.277-.002-.414-.016-.119-.012-.266-.024-.356-.111-.03-.03-.073.007-.055.043.02.04.041.077.066.115.024.037.079.005.06-.036l-.036-.08-.06.035.126.237.055-.044a.364.364 0 0 1-.088-.168l-.064.027.139.254c.022.04.083.004.06-.036z",
    fill: "#B7B73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.627 17.113c.032.06.08.11.138.144.015.01.039.004.048-.012a.037.037 0 0 0-.012-.049l-.019-.012-.01-.007-.001-.001-.002-.001a.337.337 0 0 1-.047-.047l-.007-.009.001.001-.003-.004a.347.347 0 0 1-.024-.04.035.035 0 0 0-.049-.012.037.037 0 0 0-.012.049z",
    fill: "#B7B73A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.503 16.993c.071.191.188.363.342.497.033.03.083-.02.049-.05a1.156 1.156 0 0 1-.324-.466c-.015-.042-.083-.024-.068.019z",
    fill: "#B7B73A"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.718 10.95)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#88B7C2",
    fillRule: "nonzero",
    d: "m15.984 1.328 1.323.004-.004 1.527-1.323-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB6E76",
    fillRule: "nonzero",
    d: "m25.577 4.033 2.373 1.965-1.518 1.859-2.373-1.966zM9.535 5.292 7 7.042 5.649 5.058l2.533-1.75z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#88B7C2",
    fillRule: "nonzero",
    cx: 16.41,
    cy: 17.398,
    rx: 14.661,
    ry: 14.763
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 16.41,
    cy: 17.398,
    rx: 12.68,
    ry: 12.768
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB6E76",
    fillRule: "nonzero",
    d: "m13.416 0 6.116.01-.002 1.608-6.117-.01z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.015)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 16.245,
    cy: 16.245,
    rx: 11.447,
    ry: 11.527
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.34 24.396c4.47-4.502 4.47-11.8 0-16.302a11.392 11.392 0 0 0-16.19 0c-4.47 4.502-4.47 11.8 0 16.302a11.392 11.392 0 0 0 16.19 0z",
    stroke: "#003C48",
    strokeWidth: 0.1,
    strokeDasharray: 0.675
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#EF4748",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.36 15.593c-.068-1.102-.869-2.053-1.831-2.581-.772-.423-1.695-.622-2.543-.39-1.674.459-2.532 2.5-2.205 4.214.328 1.715 1.536 3.121 2.834 4.28 1.297 1.16 2.742 2.18 3.805 3.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.27 15.694c.044-1.103.824-2.072 1.775-2.62.762-.44 1.68-.66 2.533-.447 1.683.42 2.587 2.441 2.297 4.164-.29 1.722-1.467 3.154-2.74 4.342-1.27 1.188-2.693 2.24-3.725 3.643"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m12.83 18.866 1.41-.005c.059 0 .122-.043.135-.104.13-.61.336-1.2.617-1.756l-.257-.034c.168.99.273 1.99.316 2.993.003.07.052.13.122.14.064.007.143-.032.155-.102a6.164 6.164 0 0 1 .7-1.983l-.258-.034.408 1.012c.05.126.226.141.271 0l.753-2.34h-.271c.267 1.079.487 2.169.659 3.266.021.135.251.136.271 0 .108-.72.244-1.435.41-2.144l-.136.104 1.592.052c.181.006.18-.277 0-.283l-1.592-.052A.142.142 0 0 0 18 17.7a26.908 26.908 0 0 0-.41 2.144h.271a38.362 38.362 0 0 0-.659-3.265c-.035-.141-.23-.128-.271 0l-.753 2.339h.271l-.408-1.012c-.043-.106-.192-.15-.257-.034a6.395 6.395 0 0 0-.728 2.05l.277.038a24.603 24.603 0 0 0-.326-3.068c-.02-.12-.205-.138-.257-.034a7.508 7.508 0 0 0-.646 1.823l.136-.104-1.41.005c-.181 0-.181.284 0 .283v.001z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.477 23.888)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#ABDEE6",
    x: 0.151,
    y: 11.579,
    width: 5.955,
    height: 1,
    rx: 0.418
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ABDEE6",
    x: 0.177,
    y: 13.841,
    width: 5.955,
    height: 1,
    rx: 0.418
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ABDEE6",
    x: 0.122,
    y: 16.087,
    width: 5.955,
    height: 1,
    rx: 0.418
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFE6EB",
    d: "M1.892 1.848h2.451v1.084H1.892z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DCF0F1",
    y: 9.776,
    width: 6.197,
    height: 1.881,
    rx: 0.242
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#7ABEE9",
    x: 0.003,
    y: 5.145,
    width: 6.236,
    height: 4.667,
    rx: 0.322
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DCF0F1",
    x: 0.043,
    y: 12.202,
    width: 6.197,
    height: 1.881,
    rx: 0.242
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DCF0F1",
    x: 0.029,
    y: 14.459,
    width: 6.197,
    height: 1.881,
    rx: 0.242
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.337 16.733h5.609c.162 0 .293.132.293.295v1.242c0 .694-.559 1.257-1.248 1.257h-3.7A1.254 1.254 0 0 1 .042 18.27v-1.242c0-.163.132-.295.294-.295zM2.611 2.753h1.073A2.599 2.599 0 0 1 6.273 5.36H.023A2.599 2.599 0 0 1 2.61 2.753z",
    fill: "#DCF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEE1F1",
    d: "M1.697 2.305h2.794v1H1.697z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.269 0h1.623c.409 0 .74.334.74.746v.831a.278.278 0 0 1-.276.279H1.804a.278.278 0 0 1-.277-.279v-.83c0-.413.332-.747.74-.747h.002z",
    fill: "#59A5DA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.366 29.976c.007.299.011.606-.093.885-.125.337-.396.6-.55.924-.094.2-.142.427-.107.646a.766.766 0 0 0 .348.54c.149.089.327.113.5.115.23.002.475-.039.642-.196.158-.15.218-.376.24-.593a2.323 2.323 0 0 0-.452-1.612c-.183-.242-.418-.455-.515-.743",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.758 30.38)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#393839",
    strokeWidth: 1.296,
    cx: 17.686,
    cy: 8.746,
    rx: 4.056,
    ry: 4.048
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#393839",
    strokeWidth: 1.296,
    cx: 4.056,
    cy: 8.799,
    rx: 4.056,
    ry: 4.048
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.881 8.787 5.003-5.184s.006-.004.01-.004l6.818.081c.01 0 .016.013.008.02l-5.478 5.164s-.005.003-.009.003l-6.343-.06a.012.012 0 0 1-.008-.02z",
    stroke: "#A9B659",
    strokeWidth: 1.014
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A7893",
    fillRule: "nonzero",
    d: "m8.135 1.618.272 1.108h.427l-.272-1.173z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.199 2.713 1.306 5.55a.058.058 0 0 0 .064.046l.663-.075a.059.059 0 0 0 .05-.072L9.01 2.656a.058.058 0 0 0-.06-.045l-.695.03a.059.059 0 0 0-.054.072h-.001z",
    fill: "#A9B659",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1A7893",
    fillRule: "nonzero",
    cx: 10.161,
    cy: 8.815,
    rx: 1.332,
    ry: 1.341
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#434345",
    strokeWidth: 0.62,
    fill: "#5F6062",
    fillRule: "nonzero",
    d: "m10.204 8.913.607 1.803"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7D7E81",
    strokeWidth: 0.676,
    fill: "#1A7893",
    fillRule: "nonzero",
    strokeLinecap: "round",
    d: "M10.326 10.86h1.153"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#024D60",
    strokeWidth: 0.62,
    fill: "#1A7893",
    fillRule: "nonzero",
    strokeLinecap: "round",
    d: "M8.851 6.67h1.154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.817.65a1.606 1.606 0 0 0-.442-.068.335.335 0 0 0-.143.022c-.096.042-.148.155-.183.262-.065.2-.098.411-.098.623 0 .061.005.128.041.175.046.058.125.064.194.066.742.016 1.485 0 2.227-.017.117-.003.238-.006.343-.064.104-.058.186-.186.161-.313-.029-.145-.173-.217-.3-.263A8.236 8.236 0 0 0 7.235.585",
    fill: "#272523",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.432 4.057 1.906 4.89c.075.193.275.3.465.247.226-.063.346-.32.257-.55L16.172 3.75a.394.394 0 0 0-.44-.255l-.018.004c-.24.048-.376.316-.282.558z",
    fill: "#A9B659",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1A7893",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.136.644c.359.103.694.288.974.536.098.088.193.188.23.315.018.062.02.127.023.192l.02.467c.002.024.003.048.012.07.034.08.161.076.22.01.06-.064.069-.16.074-.248.011-.172.019-.345-.013-.514a.75.75 0 0 0-.24-.444c-.048-.039-.1-.07-.154-.1a9.282 9.282 0 0 0-.977-.519.192.192 0 0 0-.097-.023c-.08.01-.112.105-.13.182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.098.78c.36.106.71.294.976.56a.461.461 0 0 1 .13.193c.026.093.02.196.024.292.004.11.007.22.014.33.008.115.049.215.165.256.187.066.356-.075.4-.253.025-.099.026-.206.03-.307a1.954 1.954 0 0 0-.013-.324.965.965 0 0 0-.241-.552c-.143-.15-.335-.231-.504-.327a7.583 7.583 0 0 0-.632-.328c-.113-.051-.238-.114-.356-.038-.086.055-.127.154-.15.25-.04.177.231.253.272.075.005-.022.011-.05.02-.068 0-.002.01-.027.016-.025.027.009-.03.014-.03.014 0 .007.231.104.253.115.166.081.328.17.487.262l.229.132c.07.04.14.079.196.137.103.107.15.26.166.405.01.09.009.181.005.271-.003.078 0 .166-.022.242-.003.01-.02.048-.013.04-.006.007-.032.016-.033.01-.001-.006.062.02.035.023v-.012c.007-.006-.003-.072-.003-.082l-.004-.082c-.007-.178.01-.382-.048-.553-.053-.159-.171-.282-.296-.388a2.704 2.704 0 0 0-1-.54c-.174-.052-.248.221-.074.272h.001z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m15.996 3.937-.03-1.693a.395.395 0 0 0-.327-.392l-.019-.003c-.242-.038-.461.167-.456.426l.036 1.652",
    fill: "#A9B659",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#272523",
    strokeWidth: 1.071,
    fill: "#272523",
    fillRule: "nonzero",
    strokeLinecap: "round",
    d: "m12.887 0 1.068.44"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.028 6.704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.45 7.17 1.196 2.387C.524 1.4 1.166-.001 2.289 0l6.505.008c1.104.001 1.75 1.365 1.116 2.354L6.842 7.145c-.265.413-.702.65-1.163.633l-.184-.008A1.334 1.334 0 0 1 4.45 7.17h.001z",
    stroke: "#29383F",
    strokeWidth: 1.521
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98 14.305A5.822 5.822 0 0 1 0 9.215C0 6 2.587 3.395 5.778 3.395c3.19 0 5.778 2.605 5.778 5.818a5.822 5.822 0 0 1-2.87 5.028",
    fill: "#29383F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 5.642,
    cy: 9.077,
    rx: 2.1,
    ry: 2.114
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtLifestyle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-lifestyle.872c24c612143d9dbc15790263a29690.svg";